var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_1523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.155 21.3158L21.8137 18.0407L16.155 14.7656V21.3158Z",
    fill: "#2E1A47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3218 0.55957C8.71586 0.55957 0.926025 8.38772 0.926025 18.0409C0.926025 27.6941 8.71586 35.5223 18.3218 35.5223C27.9278 35.5223 35.7176 27.6941 35.7176 18.0409C35.7176 8.38772 27.9278 0.55957 18.3218 0.55957ZM29.1916 18.0588C29.1916 18.0588 29.1916 21.6041 28.744 23.3137C28.4932 24.2494 27.759 24.9872 26.8278 25.239C25.1266 25.689 18.3218 25.689 18.3218 25.689C18.3218 25.689 11.5348 25.689 9.81584 25.2212C8.88468 24.9693 8.15048 24.2313 7.89964 23.2955C7.45184 21.6041 7.45184 18.0409 7.45184 18.0409C7.45184 18.0409 7.45184 14.4959 7.89964 12.7863C8.15021 11.8506 8.90247 11.0946 9.81584 10.8428C11.517 10.3928 18.3218 10.3928 18.3218 10.3928C18.3218 10.3928 25.1266 10.3928 26.8278 10.8607C27.759 11.1125 28.4932 11.8506 28.744 12.7863C29.2096 14.4959 29.1916 18.0588 29.1916 18.0588Z",
    fill: "#2E1A47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_1523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7916,
    height: 34.9627,
    fill: "white",
    transform: "translate(0.926025 0.55957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.772a4dddaec49d289b07d912e11e94da.svg";
export { ForwardRef as ReactComponent };